module.exports = __webpack_public_path__ + "img/ico_top_03.055126dd.png";